import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import { InterviewHistoryAction } from "./../../../Redux/action/InterviewHistoryAction";
import { ToastContainer, toast } from "react-toastify";
import Pagination from '../../Common/Pagination/Pagination';
import { getInterviewAllRoundByUUId } from "../../../Services/interviewService";
import { FaEye } from "react-icons/fa";
import Loader from "../../Common/Loader/loader";


// -----------------------------------------------------------------------------------------------------
const InterviewAllRounds = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { myData } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [allRoundData, setAllRoundData] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const userInfo = useSelector((state) => state.InterviewHistory.result.content);
  const totalPages = useSelector((state) => state.InterviewHistory.result.totalPages);

  let dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    getInterviewAllRoundByUUId(id).then((res) => {
      setAllRoundData(res);
      setLoading(false);
    });
  }, [pageNumber]);

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  return (
    <div>
      <ToastContainer />
      <div
        className=""
      >
        <div className="common_wrapper mt-4">
          <div className="card-header common_table_header">
            Interview All Rounds
          </div>
          <div className="card-body" style={{ overflowY: "auto" }}>
            <table className="table-data" style={{ width: "100%", textAlign: "center", fontSize: '14px' }}>
              <thead>
                <tr>
                  <th className="fw_500" scope="col">Round ID</th>
                  <th className="fw_500" scope="col">Candidate Name</th>
                  <th className="fw_500" scope="col">Round</th>
                  <th className="fw_500" scope="col">Designation</th>
                  <th className="fw_500" scope="col">Date</th>
                  <th className="fw_500" scope="col">Start time</th>
                  <th className="fw_500" scope="col">Duration</th>
                  <th className="fw_500" scope="col">Interview Type</th>
                  <th className="fw_500" scope="col">Interview Status</th>
                  {/* <th className="fw_500" scope="col">Status</th> */}
                  <th className="fw_500" scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  // Show loader when loading is true
                  <tr>
                    <td colSpan="10" style={{ height: "200px", textAlign: "center", verticalAlign: "middle" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <Loader />
                      </div>
                    </td>
                  </tr>
                ) : (
                  allRoundData &&
                    allRoundData?.rounds?.length > 0 ? (
                    allRoundData?.rounds?.map((item, i) => (
                      <tr
                        key={i}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(
                            `${myData === "team"
                              ? "/teammember-more-info/"
                              : "/scheduled-more-info/"
                            }${item.interviewId}`
                          )
                        }
                      >
                        <td>{item.interviewId}</td>
                        <td>{allRoundData?.candidateName}</td>
                        <td>{item.round}</td>
                        <td>{allRoundData.jobPosition}</td>
                        <td>
                          {item?.interviewDate
                            ? `${item.interviewDate.split(" ")[0].split("-")[2]}-${item.interviewDate.split(" ")[0].split("-")[1]}-${item.interviewDate.split(" ")[0].split("-")[0]}`
                            : "N/A"}
                        </td>
                        <td>{item.interviewStartTime || "N/A"}</td>
                        <td>{item.duration}</td>
                        <td>{item.inteviewType}</td>
                        <td>
                          <div
                            style={{ minWidth: "80%" }}
                            className={`w-75 m-auto ${["ONHOLD", "PENDING"].includes(item.candidateInterviewStatus)
                              ? "yellow_status"
                              : ["CANCELLED", "REJECT"].includes(item.candidateInterviewStatus)
                                ? "red_status"
                                : ["SELECT", "NEXT_ROUND"].includes(item.candidateInterviewStatus)
                                  ? "green_status"
                                  : ""
                              }`}
                          >
                            {item.candidateInterviewStatus === "ONHOLD"
                              ? "On Hold"
                              : item.candidateInterviewStatus === "NEXT_ROUND"
                                ? "Next Round"
                                : item.candidateInterviewStatus === "SELECT"
                                  ? "Selected"
                                  : item.candidateInterviewStatus === "REJECT"
                                    ? "Rejected"
                                    : item.candidateInterviewStatus === "PENDING"
                                      ? "In Progress"
                                      : item.candidateInterviewStatus}
                          </div>
                        </td>
                        <td>
                          <FaEye size={20} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    // Show message if no data is found
                    <tr>
                      <td colSpan="9" style={{ textAlign: "center", padding: "20px" }}>
                        No records found
                      </td>
                    </tr>
                  )
                )}

              </tbody>
            </table>
            {/* {userInfo?.length === 0 && (
              <div className="text-center mt-5">
                <h5>No Data Available</h5>
              </div>
            )} */}
          </div>
        </div>
      </div>
      {
        totalPages > 0 &&
        <Pagination totalPages={totalPages} currentPage={pageNumber} onPageChange={handlePageChange} />
      }
    </div>
  );
};

export default InterviewAllRounds;
